/* Dog Home Page behaviors — hero slider only; carousels reuse dog-landing.js. */
(function () {
  'use strict';

  function initHeroSlider(root) {
    root.querySelectorAll('[data-dhp-hero]').forEach(function (hero) {
      if (hero.dataset.dhpInit) return;
      hero.dataset.dhpInit = '1';
      var slides = hero.querySelectorAll('.dhp-hero__slide');
      var dotsWrap = hero.querySelector('.dhp-hero__dots');
      if (slides.length < 2) {
        if (slides[0]) slides[0].classList.add('is-active');
        if (dotsWrap) dotsWrap.hidden = true;
        return;
      }
      var idx = 0;
      var interval = parseInt(hero.dataset.interval, 10) || 6;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var dots = [];
      dotsWrap.innerHTML = '';
      slides.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        d.addEventListener('click', function () { show(i); restart(); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
      function show(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === idx); });
      }
      var timer = null;
      function restart() {
        if (timer) clearInterval(timer);
        if (reduceMotion) return;
        timer = setInterval(function () { show(idx + 1); }, interval * 1000);
      }
      show(0);
      restart();
    });
  }

  function initAll(root) { initHeroSlider(root || document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
